// Add unique utils for Maintenance Assistant here. Consider putting all other utils into the rotec-components library

import { ToastV2Service, BackendResponse } from '@schenck/rotec-components';

/**
 * Reacts to errors by opening a toast. In case of 400 the reason, in case of 404/500 a generic error msg.
 */
export function openErrorToast(toastService: ToastV2Service) {
  return BackendResponse.reactToResponse<any>({
    success: () => {},
    badRequest: (msg) => toastService.open({ type: 'error', text: msg }),
    errorDefault: () =>
      toastService.open({
        type: 'error',
        text: 'TECHNICAL_ERROR_try again later or contact admin',
      }),
  });
}

export function objContainsFilterStr(filterObject: any, filterString: string) {
  return Object.keys(filterObject).some((key) => {
    if (filterObject[key] && typeof filterObject[key] === 'string') {
      return filterObject[key].toLowerCase().includes(filterString.toLowerCase());
    }
  });
}
